import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'rdf-table-header-controls',
  templateUrl: './table-header-controls.component.html',
  styleUrls: ['./table-header-controls.component.css']
})
export class TableHeaderControlsComponent implements OnInit {
  @Input() column
  @Input() emittables
  @Output() onEditColumn = new EventEmitter<any>();
  @Output() onDeleteColumn = new EventEmitter<any>();
  showInputs = false
  constructor() { }

  ngOnInit() {
  }

  editingColumn() {
    this.onEditColumn.emit()
  }
  deleteColumn() {
    this.onEditColumn.emit()
  }

}
